import { Button, Dialog, Icon, Icons, Intent } from 'construct-ui';
import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';
import DatePickerComponent from '../../../../components/date-picker/date-picker.component';
import MultiSelectComponent from '../../../../components/multi-select/multi-select.component';
import paginationComponent from '../../../../components/pagination/pagination.component';
import SingleSelectComponent from '../../../../components/single-select/single-select.component';
import UDFComponent from '../../../../components/udf/udf.component';
import { codeMasterType, formats } from "../../../../config/constants";
import codeMasterModel from '../../../../models/common/code-master.model';
import userSearchModal from '../../../../models/common/user-search.modal';
import languageModel from '../../../../models/language.model';
import loginModel from "../../../../models/login.model";
import userModel from '../../../../models/user/user.model';
import ViewBase from "../../../view-base.view";
import UserDetailsView from '../details/user-details.view';
import UserEditInfoView from '../edit/user-edit-info.view';
import UserEditMapView from '../edit/user-edit-map.view';
import UserEditUdfView from '../edit/user-edit-udf.view';

/**
 * User Search View
 * 
 * The user search view page
 * 
 * @author Darrus Goh
 */
export default function UserSearchView() {
  ViewBase.call(this);

  const DIALOG_TYPES = {
    DETAILS: {
      get title() { return languageModel.getText("LT00000108", "Details") },
      content: UserDetailsView
    },
    EDIT_INFO: {
      get title() { return languageModel.getText("LT00000223", "General Information") },
      content: UserEditInfoView
    },
    EDIT_MAP: {
      get title() { return languageModel.getText("LT00000222", "Country Data Map") },
      content: UserEditMapView
    },
    EDIT_UDF: {
      get title() { return languageModel.getText("LT00000008", "UDF Management") },
      content: UserEditUdfView
    },
  };

  const DEFAULT_FILTERS = {
    userTypes: [],
    userRoles: [],
    divisions: [],
    userStatuses: [],
    updateDateFrom: '',
    updateDateTo: '',
    userID: '',
    userName: '',
    userUDF: []
  };

  const DEFAULT_PAGINATION = {
    pageIndex: 1,
    pageSize: 10,
    total: 0
  }

  let userTypes = [];
  let userRoles = [];
  let divisions = [];
  let userStatuses = [];
  let udfList = [];
  let udfValueList = [];

  let inputFilter = structuredClone(DEFAULT_FILTERS);
  let pagination = structuredClone(DEFAULT_PAGINATION);
  let users = [];
  let selectedUser = null;
  let selectedDialog = null;

  let getRequestParams = () => {
    let requestParams = Object.assign({
      pageIndex: pagination.pageIndex,
      pageSize: pagination.pageSize,
      userUDF: []
    },
      inputFilter.userTypes.length > 0 ? { userType: inputFilter.userTypes.map(e => e.code).join('^') } : null,
      inputFilter.userRoles.length > 0 ? { userRoleCode: inputFilter.userRoles.map(e => e.code).join('^') } : null,
      inputFilter.divisions.length > 0 ? { divisionGroup: inputFilter.divisions.map(e => e.code).join('^') } : null,
      inputFilter.userStatuses.length > 0 ? { statusCode: inputFilter.userStatuses.map(e => e.code).join('^') } : null,
      inputFilter.updateDateFrom != '' ? { updateDateFrom: moment(inputFilter.updateDateFrom).format(formats.apiDateFormat) } : null,
      inputFilter.updateDateTo != '' ? { updateDateTo: moment(inputFilter.updateDateTo).format(formats.apiDateFormat) } : null,
      inputFilter.userID != '' ? { userID: inputFilter.userID } : null,
      inputFilter.userName != '' ? { userName: inputFilter.userName } : null
    );

    if (inputFilter.userUDF.length > 0) {
      inputFilter.userUDF.map(udf => {
        const selectedUdf = {};
        if (udf.value && udf.value !== '') {
          if (udf.type === 'Dropdown') {
            if (udf.value.length > 0) {
              selectedUdf.udfId = udf.attributeId;
              selectedUdf.udfValue = udf.value;
              requestParams.userUDF.push(selectedUdf);
            }
          } else {
            selectedUdf.udfId = udf.attributeId;
            selectedUdf.udfValue = [udf.value];
            requestParams.userUDF.push(selectedUdf);
          }
        }
      });
    }

    return requestParams;
  };

  const getUserTypes = () => {
    codeMasterModel.getByCategoryV2({ category: codeMasterType.userType, country: loginModel.credentials.country })
      .then((result) => {
        userTypes = result;
      })
      .catch((error) => {
        this.handleError(error);
      })
  }

  const getUserRoles = () => {
    codeMasterModel.getByCategoryV2({ category: codeMasterType.userRole, country: loginModel.credentials.country })
      .then((result) => {
        userRoles = result;
      })
      .catch((error) => {
        this.handleError(error);
      })
  }

  const getDivisions = () => {
    codeMasterModel.getByCategoryV2({ category: codeMasterType.divisionGroup, country: loginModel.credentials.country })
      .then((result) => {
        divisions = result;
      })
      .catch((error) => {
        this.handleError(error);
      })
  }

  const getUserStauses = () => {
    codeMasterModel.getByCategoryV2({ category: codeMasterType.userStatus, country: loginModel.credentials.country })
      .then((result) => {
        userStatuses = result;
      })
      .catch((error) => {
        this.handleError(error);
      })
  }

  const getUDFList = () => {
    udfList = [];
    udfValueList = [];
    userSearchModal.getUDFList(
      (result) => {
        if (result?.udfAttributes) {
          result.udfAttributes.map(udf => udfList.push({ ...udf }));
        }
        if (result?.udfValues) {
          result.udfValues.map(val => udfValueList.push({ ...val }));
        }
      },
      (error) => {
        this.handleError(error);
      },
      loginModel.credentials.country
    )
  }

  const excelDownload = () => {
    this.showLoading();
    const fileName = inputFilter?.userID ? `User-${inputFilter.userID}-${uuidv4()}` : `User-${uuidv4()}`;
    userModel.downloadUserList(
      (result) => {
        this.hideLoading();
      }, (error) => {
        this.hideLoading();
        this.handleError(error);
      },
      getRequestParams(), fileName);
  }

  const addUdfElement = (udf) => {
    inputFilter.userUDF.push({ ...udf });
  }

  const removeUdfElement = (index) => {
    inputFilter.userUDF.splice(index, 1);
  }

  const onSearch = (e) => {
    e.preventDefault();
    pagination = structuredClone(DEFAULT_PAGINATION);
    getUserList();
  }

  const onClear = () => {
    inputFilter = structuredClone(DEFAULT_FILTERS);
  }

  const onPageSizeChanged = (_, pageSize) => {
    pagination.pageSize = pageSize;
    getUserList();
  }

  const onPageChanged = (pageIndex) => {
    pagination.pageIndex = pageIndex;
    getUserList();
  }

  const getUserList = () => {
    this.showLoading();
    userModel.getUserList(
      (result) => {
        this.hideLoading();
        users = result.data;
        pagination.total = result.total;
      }, (error) => {
        this.hideLoading();
        this.handleError(error);
      },
      getRequestParams());
  }

  const showPopup = (dialog, user) => {
    selectedDialog = dialog;
    selectedUser = user;
  }

  const onCloseDialog = (o, result) => {
    if (result) {
      this.showMessage(
        this.getText("EM00000311", "User updated successfully."),
        this.getText("EM00000004", "Success"),
        () => { selectedDialog = null; }
      );
    } else {
      selectedDialog = null;
    }
  }

  return {
    oninit: () => {
      getUserTypes();
      getUserRoles();
      getDivisions();
      getUserStauses();
      getUDFList();
    },
    view: () => {
      return [
        m('.vstack.gap-2',
          // Search section
          m('.d-flex.flex-column.align-items-end',
            m('a.btn.btn-primary[data-bs-toggle="collapse"][href="#search-section"][aria-controls="search-section"][aria-expanded="true"]',
              m('i.bi.bi-filter'),
              this.getText("LT00000232", "Filter"),
            )
          ),
          m('#search-section.align-self-stretch.collapse.show',
            m('.card',
              m('.card-body',
                m('form[novalidate]', { onsubmit: onSearch },
                  m('.row.g-3',
                    m('.col-3',
                      m('label.form-label', this.getText('LT00000193', 'User Type')),
                      m(MultiSelectComponent, {
                        items: userTypes,
                        selectedItems: inputFilter.userTypes,
                        filterable: false,
                        onSelect: (v) => { inputFilter.userTypes = v }
                      })
                    ),
                    m('.col-3',
                      m('label.form-label', this.getText('LT00000060', 'User Role')),
                      m(MultiSelectComponent, {
                        items: userRoles,
                        selectedItems: inputFilter.userRoles,
                        onSelect: (v) => { inputFilter.userRoles = v }
                      }),
                    ),
                    m('.col-3',
                      m('label.form-label', this.getText('LT00000233', 'Division')),
                      m(MultiSelectComponent, {
                        items: divisions,
                        selectedItems: inputFilter.divisions,
                        filterable: false,
                        onSelect: (v) => { inputFilter.divisions = v }
                      }),
                    ),
                    m('.col-3',
                      m('label.form-label', this.getText('LT00000221', 'User Status')),
                      m(MultiSelectComponent, {
                        items: userStatuses,
                        selectedItems: inputFilter.userStatuses,
                        filterable: false,
                        onSelect: (v) => { inputFilter.userStatuses = v }
                      }),
                    ),
                    m('.col-6',
                      m('label.form-label', this.getText('LT00000234', 'Last Updated Date')),
                      m(DatePickerComponent, {
                        class: 'form-control',
                        isRange: true,
                        dateStart: inputFilter.updateDateFrom,
                        dateEnd: inputFilter.updateDateTo,
                        onselect: (e) => {
                          inputFilter.updateDateFrom = e.detail.start;
                          inputFilter.updateDateTo = e.detail.end;
                        }
                      })
                    ),
                    m('.col-sm-3',
                      m('label.form-label[for=txtUserName]', this.getText("LT00000050", "User Name")),
                      m('input.form-control', {
                        placeholder: this.getText("LT00000050", "User Name"),
                        id: 'txtUserName',
                        value: inputFilter.userName,
                        onchange: (e) => { inputFilter.userName = e.target.value; }
                      }),
                    ),
                    m('.col-sm-3',
                      m('label.form-label[for=txtUserID]', this.getText("LT00000049", "User ID")),
                      m('input.form-control', {
                        placeholder: this.getText("LT00000049", "User ID"),
                        id: 'txtUserID',
                        value: inputFilter.userID,
                        onchange: (e) => { inputFilter.userID = e.target.value; }
                      })
                    ),
                    inputFilter.userUDF.length > 0 &&
                    inputFilter.userUDF.map((udf, index) =>
                      m('.col-md-2',
                        m('.d-flex.justify-content-between',
                          m('label.form-label', udf.name),
                          m(Icon, {
                            intent: Intent.NEGATIVE,
                            name: Icons.X,
                            onclick: () => removeUdfElement(index),
                            size: 'lg',
                          }),
                        ),
                        m(UDFComponent, {
                          type: udf.type,
                          items: udfValueList.filter(v => v.attributeId === udf.attributeId),
                          value: udf.value,
                          onChange: e => {
                            if (udf.type === 'Dropdown') {
                              udf.value = e;
                            } else {
                              udf.value = e.target.value;
                            }
                          }
                        }),
                      )
                    ),
                    m('.col-md-2',
                      m('label.form-label-empty'),
                      m(SingleSelectComponent, {
                        items: udfList.filter(e => !inputFilter.userUDF.map(x => x.attributeId).includes(e.attributeId)),
                        itemKey: 'attributeId',
                        itemValue: 'name',
                        onSelect: addUdfElement,
                        isButton: true,
                        allowEmpty: false,
                        buttonAttrs: {
                          class: 'form-control',
                          label: this.getText("LT00000324", "Add User Defined Field(s)"),
                          fluid: false,
                          intent: Intent.POSITIVE,
                          outlined: false,
                        },
                      }),
                    ),
                    m('.col-12',
                      // Search & clear buttons
                      m('.d-flex.justify-content-end.gap-2',
                        m('button.btn.btn-primary', {
                        }, this.getText("LT00000001", "Search")),
                        m('button.btn.btn-white', {
                          type: 'button',
                          onclick: onClear
                        }, this.getText("LT00000031", "Clear")),
                      )
                    )
                  )
                )
              )
            )
          ),
          // Table section
          m('.card',
            m('.card-body.pt-3',
              // Download button
              m('.d-flex.justify-content-end.mb-2',
                m('a.btn.btn-primary', {
                  class: users.length === 0 ? 'disabled' : '',
                  onclick: excelDownload
                },
                  m('i.bi.bi-file-earmark-arrow-down-fill'), this.getText("LT00000018", "Excel Download"),
                )
              ),
              // Search result
              m('.row',
                m('.col-12.p-0',
                  m(".table-responsive",
                    m("table.table",
                      m("thead.thead-bggrey",
                        m("tr",
                          [
                            m("th", { "scope": "col" }, this.getText("LT00000049", "User ID")),
                            m("th", { "scope": "col" }, this.getText("LT00000050", "User Name")),
                            m("th", { "scope": "col" }, this.getText("LT00000190", "Email")),
                            m("th", { "scope": "col" }, this.getText("LT00000275", "Single ID")),
                            m("th", { "scope": "col" }, this.getText("LT00000060", "User Role")),
                            m("th", { "scope": "col" }, this.getText("LT00000233", "Division")),
                            m("th", { "scope": "col" }, this.getText("LT00000221", "User Status")),
                            m("th", { "scope": "col" }, this.getText("LT00000108", "Details")),
                            m("th", { "scope": "col" }, this.getText("LT00000276", "Info")),
                            m("th", { "scope": "col" }, this.getText("LT00000277", "Map")),
                            m("th", { "scope": "col" }, this.getText("LT00000278", "UDF"))
                          ])
                      ),
                      m("tbody",
                        users.length > 0
                          ? users.map(function (user, index) {
                            return [
                              m("tr", {
                                "class": "", "data-bs-toggle": "collapse", "data-bs-target": "#gc_collapse_" + index,
                                "aria-expanded": "false", "aria-controls": "gc_collapse_" + index
                              },
                                [
                                  m("td", user.userID),
                                  m("td", user.userName),
                                  m("td", user.email),
                                  m("td", user.singleID),
                                  m("td", user.userRoleCode),
                                  m("td", user.divisionGroup),
                                  m("td", user.statusName),
                                  m("td",
                                    m(Button, {
                                      'data-id': user.userID,
                                      style: 'margin: 5px; background: #009ef7;border-color: transparent;',
                                      iconLeft: Icons.FILE_TEXT,
                                      intent: 'primary',
                                      size: 'xs',
                                      onclick: () => { showPopup(DIALOG_TYPES.DETAILS, user) }
                                    }),
                                  ),
                                  m("td",
                                    loginModel.credentials.admin &&
                                    m(Button, {
                                      'data-id': user.userID,
                                      style: 'margin: 5px; background: #009ef7;border-color: transparent;',
                                      iconLeft: Icons.EDIT,
                                      intent: 'primary',
                                      size: 'xs',
                                      onclick: () => { showPopup(DIALOG_TYPES.EDIT_INFO, user) }
                                    }),
                                  ),
                                  m("td",
                                    loginModel.credentials.admin &&
                                    m(Button, {
                                      'data-id': user.userID,
                                      style: 'margin: 5px; background: #009ef7;border-color: transparent;',
                                      iconLeft: Icons.EDIT,
                                      intent: 'primary',
                                      size: 'xs',
                                      onclick: () => { showPopup(DIALOG_TYPES.EDIT_MAP, user) }
                                    }),
                                  ),
                                  m("td",
                                    loginModel.credentials.admin &&
                                    m(Button, {
                                      'data-id': user.userID,
                                      style: 'margin: 5px; background: #009ef7;border-color: transparent;',
                                      iconLeft: Icons.EDIT,
                                      intent: 'primary',
                                      size: 'xs',
                                      onclick: () => { showPopup(DIALOG_TYPES.EDIT_UDF, user) }
                                    }),
                                  )
                                ]
                              )
                            ]
                          })
                          : m("tr",
                            m("td.text-center", { "colspan": "11" }, this.getText("EM00000141", "No records found."))
                          )
                      )
                    )
                  ),
                  users.length > 0 &&
                  m(".px-3",
                    m(paginationComponent, { currentPage: pagination.pageIndex, pageSize: pagination.pageSize, totalItems: pagination.total, onPageChanged: onPageChanged, onPageSizeChanged: onPageSizeChanged })
                  )
                )
              )
            )
          ),
        ),
        selectedDialog && m(Dialog, {
          isOpen: true,
          onClose: () => { selectedDialog = null },
          closeOnOutsideClick: false,
          transitionDuration: 200,
          title: `${this.getText("LT00000009", "User")} - ${selectedDialog.title}`,
          content: m(selectedDialog.content, { userId: selectedUser.userID, encryptedUserId: selectedUser.encryptedUserId, onClose: (o, result) => { onCloseDialog(o, result) } }),
          "class": "cui-dialog-xxl"
        }),
        this.getBaseViews()
      ];
    },
  };
}
